// _DebugConfig.js
import Utils from './_Utils';

const IS_PRODUCTION_DOMAIN = window.location.hostname === 'tatemonoen-navi.jp';

// Modify the DEBUG_MODE export
//const DEBUG_MODE = !IS_PRODUCTION_DOMAIN;
const DEBUG_MODE = false;

// Debug configuration management
const DebugConfig =
{
    // Cookie names
    COOKIE_PREFIX: 'debug_',
    COOKIES:
    {
        GPS_CHECK: 'gps_check_enabled'
    },

    // Default values
    DEFAULTS:
    {
        GPS_CHECK: true
    },

    // Get debug setting
    getSetting: (key, defaultValue = null) =>
    {
        if (!DEBUG_MODE) return defaultValue;
        return Utils.getCookie(DebugConfig.COOKIE_PREFIX + key, defaultValue);
    },

    // Save debug setting
    saveSetting: (key, value) =>
    {
        if (!DEBUG_MODE) return;
        Utils.setCookie(DebugConfig.COOKIE_PREFIX + key, value);
    },

    // Check if GPS check is enabled
    isGPSCheckEnabled: () =>
    {
        if (!DEBUG_MODE) return true; // Always enabled in non-debug mode
        return DebugConfig.getSetting(
            DebugConfig.COOKIES.GPS_CHECK,
            DebugConfig.DEFAULTS.GPS_CHECK
        );
    },

    // Force GPS check to be enabled in non-debug mode
    forceGPSCheckIfProduction: () =>
    {
        if (!DEBUG_MODE)
        {
            return true; // Always return true in production mode
        }
        // In debug mode, return the setting
        return DebugConfig.isGPSCheckEnabled();
    }
};

export { DEBUG_MODE, DebugConfig, IS_PRODUCTION_DOMAIN };